import React, { ReactElement } from 'react';

export type MultipleSelectTriggerProps = {
  id: string;
  listboxId: string;
  ariaLabel: string;
  displayText: string;
  isOpen: boolean;
  disabled: boolean;
  testId?: string;
  onToggle: VoidFunction;
  onBlur?: VoidFunction;
};

export function MultipleSelectTrigger({
  id,
  listboxId,
  ariaLabel,
  displayText,
  isOpen,
  disabled,
  testId,
  onToggle,
  onBlur,
}: MultipleSelectTriggerProps): ReactElement {
  return (
    <button
      type="button"
      id={id}
      className="multiple-select-trigger"
      role="combobox"
      aria-label={ariaLabel}
      aria-expanded={isOpen}
      aria-haspopup="listbox"
      aria-controls={listboxId}
      disabled={disabled}
      data-testid={testId}
      title={displayText}
      onClick={onToggle}
      onBlur={onBlur}
    >
      {displayText}
    </button>
  );
}
